export default __webpack_public_path__ + "static/media/home.d1168664.svg";